import { Cart } from 'src/types/common';
import { parseToNumberOrNull } from 'src/utils/numbers/parteToNumberOrNull';

const calculateCartSummary = ({
  cartData,
  b2bDeliveryFee,
  isB2b,
}: {
  cartData: Cart | undefined;
  b2bDeliveryFee: number;
  isB2b: boolean | undefined;
}) => {
  const delivery_price = isB2b
    ? b2bDeliveryFee
    : parseToNumberOrNull(cartData?.prices?.delivery_price) ?? 0;

  const subtotal = (cartData?.sub_total ?? 0).toString() ?? '0';
  const total = parseToNumberOrNull(cartData?.get_total) ?? 0;
  const total_with_coupon =
    parseToNumberOrNull(cartData?.coupon_details?.total_with_coupon) ?? 0;
  const totalQuantity = cartData?.total_quantity ?? 0;
  const couponDetails = cartData?.coupon_details;

  return {
    sub_total: subtotal,
    delivery_price,
    total,
    totalQuantity,
    couponDetails,
    total_with_coupon,
  };
};

export default calculateCartSummary;
